'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
_moment.default.locale('fr');
const {
  app
} = window;
const cv_status_list = ['accepted'];
class CandidateAccountDetails extends _react.Component {
  state = {
    loading: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchCandidate();
  }
  fetchCandidate = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/get-self').then(function (xhr, response) {
      component.setState({
        loading: false,
        candidate: response.candidate
      });
      component.fetchCv();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchCv = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/cv/get-mine').then(function (xhr, response) {
      component.setState({
        loading: false,
        cv: response.cv || {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  logout = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post('/logout').then(function (xhr, response) {
      // Update user permissions now that user is disconnected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'logout'
      });
      app.navigateTo((0, _Routes.URL)('Home'));
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let candidate = state?.candidate;
    let phone_number_parse;
    if (candidate?.home_phone_number && candidate?.phone_number) {
      phone_number_parse = candidate?.home_phone_number + ' / ' + candidate?.phone_number;
    } else if (candidate?.home_phone_number) {
      phone_number_parse = candidate?.home_phone_number;
    } else {
      phone_number_parse = candidate?.phone_number;
    }
    const show_cv = state.cv?.id ? true : cv_status_list.includes(candidate?.account_status);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account_row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account_column"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium"
    }, "Mon dossier"), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-flex u-flex-column u-full-width"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: (0, _Routes.URL)('CandidateUpdateRecord'),
      className: "c-btn u-margin-top-20"
    }, "Modifier mon dossier"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account_column"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium"
    }, "Mon CV en ligne"), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-flex u-flex-column u-full-width"
    }, state.cv?.id ? /*#__PURE__*/_react.default.createElement(_Link.default, {
      className: "c-btn",
      href: '/candidats/' + state.cv.id,
      target: "_blank"
    }, "Visualiser mon CV en ligne") : undefined, show_cv ? /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: (0, _Routes.URL)('CandidateCV'),
      className: "c-btn u-margin-top-20"
    }, state.cv?.id ? 'Modifier mon CV en ligne' : 'Créer mon CV en ligne') : undefined, !state.cv?.id && !show_cv ? /*#__PURE__*/_react.default.createElement("span", null, "Vous pourrez acc\xE9der \xE0 la cr\xE9ation de CV une fois votre dossier valid\xE9.") : undefined)), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account_column"
    }, /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium"
    }, "Mes coordonn\xE9es"), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Nom\xA0:", ' ', candidate?.lastname, ' ', candidate?.firstname), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Date de naissance\xA0:", ' ', (0, _moment.default)(candidate?.birthdate).format('DD/MM/YYYY')), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Num\xE9ro de t\xE9l\xE9phone\xA0:", ' ', phone_number_parse), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Adresse mail\xA0:", ' ', candidate?.login), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-circle-decoration c-circle-decoration--blue"
    }, "Adresse\xA0:", ' ', candidate?.address.line_1, candidate?.address.line_2 ? /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width"
    }, candidate.address.line_2) : undefined, candidate?.address.postal_code, ' ', candidate?.address.city), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: (0, _Routes.URL)('UpdateCandidateAccount'),
      className: "c-btn u-margin-top-15"
    }, "Modifier mes coordonn\xE9es")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-account_row c-account_row--actions"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.logout,
      className: "c-btn c-btn--red"
    }, "D\xE9connexion")));
  }
}
exports.default = CandidateAccountDetails;
